/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: _LGvAVvYIbnl

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import InfoSection from "../../InfoSection"; // plasmic-import: 0gf8lKLu2jNB/component
import { RawUl } from "@myevaluations/myevals-plasmic-utils/dist/code-components/RawList/Ul"; // plasmic-import: MgrwvgDVmmr8/codeComponent
import { RawLi } from "@myevaluations/myevals-plasmic-utils/dist/code-components/RawList/Li"; // plasmic-import: AzSSlTj_Nw6K/codeComponent
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import sty from "./PlasmicComplianceAndCertificationsBanner.module.css"; // plasmic-import: _LGvAVvYIbnl/css

createPlasmicElementProxy;

export type PlasmicComplianceAndCertificationsBanner__VariantMembers = {};
export type PlasmicComplianceAndCertificationsBanner__VariantsArgs = {};
type VariantPropType =
  keyof PlasmicComplianceAndCertificationsBanner__VariantsArgs;
export const PlasmicComplianceAndCertificationsBanner__VariantProps =
  new Array<VariantPropType>();

export type PlasmicComplianceAndCertificationsBanner__ArgsType = {};
type ArgPropType = keyof PlasmicComplianceAndCertificationsBanner__ArgsType;
export const PlasmicComplianceAndCertificationsBanner__ArgProps =
  new Array<ArgPropType>();

export type PlasmicComplianceAndCertificationsBanner__OverridesType = {
  banner?: Flex__<"div">;
  container?: Flex__<"section">;
  wrapper?: Flex__<"div">;
  heading?: Flex__<"div">;
  title?: Flex__<"h1">;
  contentRow?: Flex__<"div">;
  contentColumn?: Flex__<"div">;
  ourCommitmentToSecurityAndCompliance?: Flex__<typeof InfoSection>;
  soc2TypeIiCertified?: Flex__<typeof InfoSection>;
  otherComplianceFeatures?: Flex__<typeof InfoSection>;
  complianceFeatures?: Flex__<"div">;
  hipaa?: Flex__<"div">;
  gdprCompliance?: Flex__<"div">;
  ferpaCompliance?: Flex__<"div">;
  securityMeasuresYouCanTrust?: Flex__<"div">;
  dataEncryption?: Flex__<"div">;
  h4?: Flex__<"h4">;
  whyComplianceIsImportant?: Flex__<typeof InfoSection>;
  learnMore?: Flex__<typeof InfoSection>;
  freeBox?: Flex__<"div">;
  links?: Flex__<"div">;
  line?: Flex__<typeof PlasmicImg__>;
};

export interface DefaultComplianceAndCertificationsBannerProps {
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicComplianceAndCertificationsBanner__RenderFunc(props: {
  variants: PlasmicComplianceAndCertificationsBanner__VariantsArgs;
  args: PlasmicComplianceAndCertificationsBanner__ArgsType;
  overrides: PlasmicComplianceAndCertificationsBanner__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const globalVariants = _useGlobalVariants();

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"banner"}
      data-plasmic-override={overrides.banner}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_bvRZj1oZhhFBeMnkX2LkQu",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.banner
      )}
    >
      <section
        data-plasmic-name={"container"}
        data-plasmic-override={overrides.container}
        className={classNames("all", sty.container)}
      >
        <div
          data-plasmic-name={"wrapper"}
          data-plasmic-override={overrides.wrapper}
          className={classNames("all", sty.wrapper)}
        >
          <div
            data-plasmic-name={"heading"}
            data-plasmic-override={overrides.heading}
            className={classNames("all", sty.heading)}
          >
            <h1
              data-plasmic-name={"title"}
              data-plasmic-override={overrides.title}
              className={classNames(
                "all",
                "h1",
                "h1__bvRZj",
                "__wab_text",
                sty.title
              )}
            >
              {"Compliance & Certifications"}
            </h1>
          </div>
          <div
            data-plasmic-name={"contentRow"}
            data-plasmic-override={overrides.contentRow}
            className={classNames("all", sty.contentRow)}
          >
            <div
              data-plasmic-name={"contentColumn"}
              data-plasmic-override={overrides.contentColumn}
              className={classNames("all", sty.contentColumn)}
            >
              <InfoSection
                data-plasmic-name={"ourCommitmentToSecurityAndCompliance"}
                data-plasmic-override={
                  overrides.ourCommitmentToSecurityAndCompliance
                }
                className={classNames(
                  "__wab_instance",
                  sty.ourCommitmentToSecurityAndCompliance
                )}
                content={
                  <p
                    className={classNames(
                      "all",
                      "p",
                      "p__bvRZj",
                      "__wab_text",
                      sty.p___7QpMb
                    )}
                  >
                    <React.Fragment>
                      <React.Fragment>{"At "}</React.Fragment>
                      <span
                        className={
                          "plasmic_default__all plasmic_default__span plasmic_default__span__bvRZj"
                        }
                        style={{ fontWeight: 700 }}
                      >
                        {"MyEvaluations"}
                      </span>
                      <React.Fragment>
                        {
                          ", your data security and compliance are not just priorities\u2014they\u2019re part of who we are. We are dedicated to providing a safe and reliable environment for medical education management by adhering to the most rigorous industry standards.\n\nOur certifications and compliance achievements validate our promise to safeguard your data while maintaining the highest operational excellence."
                        }
                      </React.Fragment>
                    </React.Fragment>
                  </p>
                }
                heading={"Our Commitment to Security and Compliance"}
              />

              <InfoSection
                data-plasmic-name={"soc2TypeIiCertified"}
                data-plasmic-override={overrides.soc2TypeIiCertified}
                className={classNames(
                  "__wab_instance",
                  sty.soc2TypeIiCertified
                )}
                content={
                  <React.Fragment>
                    <p
                      className={classNames(
                        "all",
                        "p",
                        "p__bvRZj",
                        "__wab_text",
                        sty.p__eheDc
                      )}
                    >
                      <React.Fragment>
                        <React.Fragment>
                          {
                            "We are proud to announce that MyEvaluations has achieved "
                          }
                        </React.Fragment>
                        <span
                          className={
                            "plasmic_default__all plasmic_default__span plasmic_default__span__bvRZj"
                          }
                          style={{ fontWeight: 700 }}
                        >
                          {"SOC 2 Type II Certification"}
                        </span>
                        <React.Fragment>
                          {
                            ", ensuring that our systems and controls meet stringent standards for "
                          }
                        </React.Fragment>
                        <span
                          className={
                            "plasmic_default__all plasmic_default__span plasmic_default__span__bvRZj"
                          }
                          style={{ fontWeight: 700 }}
                        >
                          {"security"}
                        </span>
                        <React.Fragment>{", "}</React.Fragment>
                        <span
                          className={
                            "plasmic_default__all plasmic_default__span plasmic_default__span__bvRZj"
                          }
                          style={{ fontWeight: 700 }}
                        >
                          {"availability"}
                        </span>
                        <React.Fragment>{", and "}</React.Fragment>
                        <span
                          className={
                            "plasmic_default__all plasmic_default__span plasmic_default__span__bvRZj"
                          }
                          style={{ fontWeight: 700 }}
                        >
                          {"confidentiality"}
                        </span>
                        <React.Fragment>{"."}</React.Fragment>
                      </React.Fragment>
                    </p>
                    <h3
                      className={classNames(
                        "all",
                        "h3",
                        "h3__bvRZj",
                        "__wab_text",
                        sty.h3__tG3VF
                      )}
                    >
                      {"Why SOC 2 Type II Matters:"}
                    </h3>
                    <RawUl
                      className={classNames("__wab_instance", sty.rawUl__x4JOz)}
                    >
                      <RawLi
                        className={classNames(
                          "__wab_instance",
                          sty.rawLi__yogGb
                        )}
                      >
                        <p
                          className={classNames(
                            "all",
                            "p",
                            "p__bvRZj",
                            "__wab_text",
                            sty.p__eghx
                          )}
                        >
                          <React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span plasmic_default__span__bvRZj"
                              }
                              style={{ fontWeight: 700 }}
                            >
                              {"Independent Validation:"}
                            </span>
                            <React.Fragment>
                              {
                                " Our operational processes have been rigorously audited and verified by third-party assessors."
                              }
                            </React.Fragment>
                          </React.Fragment>
                        </p>
                      </RawLi>
                      <RawLi
                        className={classNames(
                          "__wab_instance",
                          sty.rawLi__g6I15
                        )}
                      >
                        <p
                          className={classNames(
                            "all",
                            "p",
                            "p__bvRZj",
                            "__wab_text",
                            sty.p__wShDd
                          )}
                        >
                          <React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span plasmic_default__span__bvRZj"
                              }
                              style={{ fontWeight: 700 }}
                            >
                              {"Proven Security Controls:"}
                            </span>
                            <React.Fragment>
                              {
                                " Our framework ensures your sensitive data is protected at all times."
                              }
                            </React.Fragment>
                          </React.Fragment>
                        </p>
                      </RawLi>
                      <RawLi
                        className={classNames(
                          "__wab_instance",
                          sty.rawLi__lADdZ
                        )}
                      >
                        <p
                          className={classNames(
                            "all",
                            "p",
                            "p__bvRZj",
                            "__wab_text",
                            sty.p__k2Ki5
                          )}
                        >
                          <React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span plasmic_default__span__bvRZj"
                              }
                              style={{ fontWeight: 700 }}
                            >
                              {"Continuous Monitoring:"}
                            </span>
                            <React.Fragment>
                              {
                                " We implement ongoing checks and updates to maintain compliance."
                              }
                            </React.Fragment>
                          </React.Fragment>
                        </p>
                      </RawLi>
                    </RawUl>
                    <p
                      className={classNames(
                        "all",
                        "p",
                        "p__bvRZj",
                        "__wab_text",
                        sty.p__s0ONe
                      )}
                    >
                      {
                        "This achievement reinforces our role as a trusted partner in medical education management."
                      }
                    </p>
                  </React.Fragment>
                }
                heading={"SOC 2 Type II Certified"}
              />

              <InfoSection
                data-plasmic-name={"otherComplianceFeatures"}
                data-plasmic-override={overrides.otherComplianceFeatures}
                className={classNames(
                  "__wab_instance",
                  sty.otherComplianceFeatures
                )}
                content={
                  <div
                    data-plasmic-name={"complianceFeatures"}
                    data-plasmic-override={overrides.complianceFeatures}
                    className={classNames("all", sty.complianceFeatures)}
                  >
                    <div
                      data-plasmic-name={"hipaa"}
                      data-plasmic-override={overrides.hipaa}
                      className={classNames("all", sty.hipaa)}
                    >
                      <h3
                        className={classNames(
                          "all",
                          "h3",
                          "h3__bvRZj",
                          "__wab_text",
                          sty.h3__wZOiz
                        )}
                      >
                        {"HIPAA Compliance"}
                      </h3>
                      <p
                        className={classNames(
                          "all",
                          "p",
                          "p__bvRZj",
                          "__wab_text",
                          sty.p__akmzF
                        )}
                      >
                        <React.Fragment>
                          <React.Fragment>
                            {
                              "For clients in healthcare settings, we adhere to the requirements of the "
                            }
                          </React.Fragment>
                          <span
                            className={
                              "plasmic_default__all plasmic_default__span plasmic_default__span__bvRZj"
                            }
                            style={{ fontWeight: 700 }}
                          >
                            {
                              "Health Insurance Portability and Accountability Act (HIPAA)"
                            }
                          </span>
                          <React.Fragment>
                            {
                              ", ensuring the security and confidentiality of protected health information (PHI)."
                            }
                          </React.Fragment>
                        </React.Fragment>
                      </p>
                      <RawUl
                        className={classNames(
                          "__wab_instance",
                          sty.rawUl__kOyN0
                        )}
                      >
                        {(_par =>
                          !_par ? [] : Array.isArray(_par) ? _par : [_par])(
                          (() => {
                            try {
                              return [
                                "Robust encryption methods for PHI.",
                                "Access controls to limit exposure to sensitive data.",
                                "Comprehensive training for compliance across all levels."
                              ];
                            } catch (e) {
                              if (
                                e instanceof TypeError ||
                                e?.plasmicType === "PlasmicUndefinedDataError"
                              ) {
                                return [];
                              }
                              throw e;
                            }
                          })()
                        ).map((__plasmic_item_0, __plasmic_idx_0) => {
                          const currentItem = __plasmic_item_0;
                          const currentIndex = __plasmic_idx_0;
                          return (
                            <RawLi
                              className={classNames(
                                "__wab_instance",
                                sty.rawLi___0Mecu
                              )}
                              key={currentIndex}
                            >
                              <p
                                className={classNames(
                                  "all",
                                  "p",
                                  "p__bvRZj",
                                  "__wab_text",
                                  sty.p__mA7JO
                                )}
                              >
                                <React.Fragment>
                                  {(() => {
                                    try {
                                      return currentItem;
                                    } catch (e) {
                                      if (
                                        e instanceof TypeError ||
                                        e?.plasmicType ===
                                          "PlasmicUndefinedDataError"
                                      ) {
                                        return "";
                                      }
                                      throw e;
                                    }
                                  })()}
                                </React.Fragment>
                              </p>
                            </RawLi>
                          );
                        })}
                      </RawUl>
                    </div>
                    <div
                      data-plasmic-name={"gdprCompliance"}
                      data-plasmic-override={overrides.gdprCompliance}
                      className={classNames("all", sty.gdprCompliance)}
                    >
                      <h3
                        className={classNames(
                          "all",
                          "h3",
                          "h3__bvRZj",
                          "__wab_text",
                          sty.h3__wadPt
                        )}
                      >
                        {"GDPR Compliance"}
                      </h3>
                      <p
                        className={classNames(
                          "all",
                          "p",
                          "p__bvRZj",
                          "__wab_text",
                          sty.p__rCtc5
                        )}
                      >
                        <React.Fragment>
                          <React.Fragment>
                            {
                              "As a global solution, MyEvaluations is compliant with the "
                            }
                          </React.Fragment>
                          <span
                            className={
                              "plasmic_default__all plasmic_default__span plasmic_default__span__bvRZj"
                            }
                            style={{ fontWeight: 700 }}
                          >
                            {"General Data Protection Regulation (GDPR)"}
                          </span>
                          <React.Fragment>
                            {
                              ", offering transparency and control over personal data for users in the European Union."
                            }
                          </React.Fragment>
                        </React.Fragment>
                      </p>
                      <RawUl
                        className={classNames("__wab_instance", sty.rawUl__dky)}
                      >
                        {(_par =>
                          !_par ? [] : Array.isArray(_par) ? _par : [_par])(
                          (() => {
                            try {
                              return [
                                "Clear data usage policies.",
                                "User control over access, portability, and deletion of personal data.",
                                "Secure handling and processing of sensitive information."
                              ];
                            } catch (e) {
                              if (
                                e instanceof TypeError ||
                                e?.plasmicType === "PlasmicUndefinedDataError"
                              ) {
                                return [];
                              }
                              throw e;
                            }
                          })()
                        ).map((__plasmic_item_0, __plasmic_idx_0) => {
                          const currentItem = __plasmic_item_0;
                          const currentIndex = __plasmic_idx_0;
                          return (
                            <RawLi
                              className={classNames(
                                "__wab_instance",
                                sty.rawLi__jZLem
                              )}
                              key={currentIndex}
                            >
                              <p
                                className={classNames(
                                  "all",
                                  "p",
                                  "p__bvRZj",
                                  "__wab_text",
                                  sty.p__bn0IB
                                )}
                              >
                                <React.Fragment>
                                  {(() => {
                                    try {
                                      return currentItem;
                                    } catch (e) {
                                      if (
                                        e instanceof TypeError ||
                                        e?.plasmicType ===
                                          "PlasmicUndefinedDataError"
                                      ) {
                                        return "";
                                      }
                                      throw e;
                                    }
                                  })()}
                                </React.Fragment>
                              </p>
                            </RawLi>
                          );
                        })}
                      </RawUl>
                    </div>
                    <div
                      data-plasmic-name={"ferpaCompliance"}
                      data-plasmic-override={overrides.ferpaCompliance}
                      className={classNames("all", sty.ferpaCompliance)}
                    >
                      <h3
                        className={classNames(
                          "all",
                          "h3",
                          "h3__bvRZj",
                          "__wab_text",
                          sty.h3__xYkh6
                        )}
                      >
                        {"FERPA Compliance"}
                      </h3>
                      <p
                        className={classNames(
                          "all",
                          "p",
                          "p__bvRZj",
                          "__wab_text",
                          sty.p__d74ON
                        )}
                      >
                        <React.Fragment>
                          <React.Fragment>
                            {
                              "Educational institutions can rely on MyEvaluations to meet the requirements of the "
                            }
                          </React.Fragment>
                          <span
                            className={
                              "plasmic_default__all plasmic_default__span plasmic_default__span__bvRZj"
                            }
                            style={{ fontWeight: 700 }}
                          >
                            {
                              "Family Educational Rights and Privacy Act (FERPA)"
                            }
                          </span>
                          <React.Fragment>
                            {
                              ", protecting the confidentiality of student records."
                            }
                          </React.Fragment>
                        </React.Fragment>
                      </p>
                    </div>
                    <div
                      data-plasmic-name={"securityMeasuresYouCanTrust"}
                      data-plasmic-override={
                        overrides.securityMeasuresYouCanTrust
                      }
                      className={classNames(
                        "all",
                        sty.securityMeasuresYouCanTrust
                      )}
                    >
                      <h3
                        className={classNames(
                          "all",
                          "h3",
                          "h3__bvRZj",
                          "__wab_text",
                          sty.h3__xwFIb
                        )}
                      >
                        {"Security Measures You Can Trust"}
                      </h3>
                      {(_par =>
                        !_par ? [] : Array.isArray(_par) ? _par : [_par])(
                        (() => {
                          try {
                            return [
                              {
                                title: "Data Encryption",
                                keyPoints: [
                                  "End-to-end encryption for all data in transit and at rest.",
                                  "Secure protocols ensuring no unauthorized access."
                                ]
                              },
                              {
                                title: "Regular Security Audits",
                                keyPoints: [
                                  "Continuous internal and external assessments of our systems.",
                                  "Proactive identification and mitigation of potential vulnerabilities."
                                ]
                              },
                              {
                                title: "Role-Based Access Control",
                                keyPoints: [
                                  "Advanced permission management to ensure only authorized personnel can access specific data."
                                ]
                              },
                              {
                                title: "Proactive Risk Management",
                                keyPoints: [
                                  "Monitoring tools and frameworks to identify, mitigate, and prevent risks to your data."
                                ]
                              }
                            ];
                          } catch (e) {
                            if (
                              e instanceof TypeError ||
                              e?.plasmicType === "PlasmicUndefinedDataError"
                            ) {
                              return [];
                            }
                            throw e;
                          }
                        })()
                      ).map((__plasmic_item_0, __plasmic_idx_0) => {
                        const currentItem = __plasmic_item_0;
                        const currentIndex = __plasmic_idx_0;
                        return (
                          <div
                            data-plasmic-name={"dataEncryption"}
                            data-plasmic-override={overrides.dataEncryption}
                            className={classNames("all", sty.dataEncryption)}
                            key={currentIndex}
                          >
                            <h4
                              data-plasmic-name={"h4"}
                              data-plasmic-override={overrides.h4}
                              className={classNames(
                                "all",
                                "h4",
                                "h4__bvRZj",
                                "__wab_text",
                                sty.h4
                              )}
                            >
                              <React.Fragment>
                                {currentItem.title}
                              </React.Fragment>
                            </h4>
                            <RawUl
                              className={classNames(
                                "__wab_instance",
                                sty.rawUl__qfoIg
                              )}
                            >
                              {(_par =>
                                !_par
                                  ? []
                                  : Array.isArray(_par)
                                    ? _par
                                    : [_par])(
                                (() => {
                                  try {
                                    return currentItem.keyPoints;
                                  } catch (e) {
                                    if (
                                      e instanceof TypeError ||
                                      e?.plasmicType ===
                                        "PlasmicUndefinedDataError"
                                    ) {
                                      return [];
                                    }
                                    throw e;
                                  }
                                })()
                              ).map((__plasmic_item_1, __plasmic_idx_1) => {
                                const currentItem = __plasmic_item_1;
                                const currentIndex = __plasmic_idx_1;
                                return (
                                  <RawLi
                                    className={classNames(
                                      "__wab_instance",
                                      sty.rawLi__gs7WM
                                    )}
                                    key={currentIndex}
                                  >
                                    <p
                                      className={classNames(
                                        "all",
                                        "p",
                                        "p__bvRZj",
                                        "__wab_text",
                                        sty.p__y9FyW
                                      )}
                                    >
                                      <React.Fragment>
                                        {(() => {
                                          try {
                                            return currentItem;
                                          } catch (e) {
                                            if (
                                              e instanceof TypeError ||
                                              e?.plasmicType ===
                                                "PlasmicUndefinedDataError"
                                            ) {
                                              return "";
                                            }
                                            throw e;
                                          }
                                        })()}
                                      </React.Fragment>
                                    </p>
                                  </RawLi>
                                );
                              })}
                            </RawUl>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                }
                heading={"Other Compliance Features"}
              />

              <InfoSection
                data-plasmic-name={"whyComplianceIsImportant"}
                data-plasmic-override={overrides.whyComplianceIsImportant}
                className={classNames(
                  "__wab_instance",
                  sty.whyComplianceIsImportant
                )}
                content={
                  <React.Fragment>
                    <p
                      className={classNames(
                        "all",
                        "p",
                        "p__bvRZj",
                        "__wab_text",
                        sty.p__fbyef
                      )}
                    >
                      {
                        "In the field of medical education and training, your data is critical. With MyEvaluations, you can trust that:"
                      }
                    </p>
                    <RawUl
                      className={classNames("__wab_instance", sty.rawUl__eDtR8)}
                    >
                      {(_par =>
                        !_par ? [] : Array.isArray(_par) ? _par : [_par])(
                        (() => {
                          try {
                            return [
                              "Your data is secure and managed responsibly.",
                              "We are transparent about our policies and certifications.",
                              "Our compliance efforts allow you to focus on education while we handle security."
                            ];
                          } catch (e) {
                            if (
                              e instanceof TypeError ||
                              e?.plasmicType === "PlasmicUndefinedDataError"
                            ) {
                              return [];
                            }
                            throw e;
                          }
                        })()
                      ).map((__plasmic_item_0, __plasmic_idx_0) => {
                        const currentItem = __plasmic_item_0;
                        const currentIndex = __plasmic_idx_0;
                        return (
                          <RawLi
                            className={classNames(
                              "__wab_instance",
                              sty.rawLi__tcrB
                            )}
                            key={currentIndex}
                          >
                            <p
                              className={classNames(
                                "all",
                                "p",
                                "p__bvRZj",
                                "__wab_text",
                                sty.p___1TuOq
                              )}
                            >
                              <React.Fragment>
                                {(() => {
                                  try {
                                    return currentItem;
                                  } catch (e) {
                                    if (
                                      e instanceof TypeError ||
                                      e?.plasmicType ===
                                        "PlasmicUndefinedDataError"
                                    ) {
                                      return "";
                                    }
                                    throw e;
                                  }
                                })()}
                              </React.Fragment>
                            </p>
                          </RawLi>
                        );
                      })}
                    </RawUl>
                  </React.Fragment>
                }
                heading={"Why Compliance Is Important"}
              />

              <InfoSection
                data-plasmic-name={"learnMore"}
                data-plasmic-override={overrides.learnMore}
                className={classNames("__wab_instance", sty.learnMore)}
                content={
                  <div
                    data-plasmic-name={"freeBox"}
                    data-plasmic-override={overrides.freeBox}
                    className={classNames("all", sty.freeBox)}
                  >
                    <p
                      className={classNames(
                        "all",
                        "p",
                        "p__bvRZj",
                        "__wab_text",
                        sty.p__dlPc6
                      )}
                    >
                      <React.Fragment>
                        <React.Fragment>
                          {
                            "Have questions about our certifications or security practices?\nContact our compliance team at "
                          }
                        </React.Fragment>
                        {
                          <PlasmicLink__
                            className={classNames(
                              "all",
                              "a",
                              "a__bvRZj",
                              "__wab_text",
                              "plasmic_default__inline",
                              sty.link__kqIa7
                            )}
                            component={Link}
                            href={"mailto:support@myevaluations.com"}
                            legacyBehavior={false}
                            platform={"nextjs"}
                          >
                            {"support@myevaluations.com"}
                          </PlasmicLink__>
                        }
                        <React.Fragment>{" or call us at "}</React.Fragment>
                        <span
                          className={
                            "plasmic_default__all plasmic_default__span plasmic_default__span__bvRZj"
                          }
                          style={{ fontWeight: 700 }}
                        >
                          {"(866) 422-0554"}
                        </span>
                        <React.Fragment>{"."}</React.Fragment>
                      </React.Fragment>
                    </p>
                    <div
                      data-plasmic-name={"links"}
                      data-plasmic-override={overrides.links}
                      className={classNames("all", sty.links)}
                    >
                      <PlasmicLink__
                        className={classNames(
                          "all",
                          "a",
                          "a__bvRZj",
                          "__wab_text",
                          sty.link__t8Ikr
                        )}
                        component={Link}
                        href={`/m/security-practices`}
                        legacyBehavior={false}
                        platform={"nextjs"}
                      >
                        {"Explore Our Security Practices"}
                      </PlasmicLink__>
                      <PlasmicLink__
                        className={classNames(
                          "all",
                          "a",
                          "a__bvRZj",
                          "__wab_text",
                          sty.link__jywH2
                        )}
                        component={Link}
                        href={
                          "https://us.aicpa.org/interestareas/frc/assuranceadvisoryservices/sorhome"
                        }
                        legacyBehavior={false}
                        platform={"nextjs"}
                        target={"_blank"}
                      >
                        {"Learn More About SOC 2 Certification"}
                      </PlasmicLink__>
                    </div>
                    <p
                      className={classNames(
                        "all",
                        "p",
                        "p__bvRZj",
                        "__wab_text",
                        sty.p__cNVn1
                      )}
                    >
                      {
                        "This tailored content positions MyEvaluations as a leader in secure, compliant medical education management, providing reassurance to clients and prospects."
                      }
                    </p>
                  </div>
                }
                heading={"Learn More"}
              />
            </div>
          </div>
          {(
            hasVariant(globalVariants, "mobile", "mobile")
              ? false
              : hasVariant(globalVariants, "mobile", "tabletPortrait")
                ? true
                : true
          ) ? (
            <PlasmicImg__
              data-plasmic-name={"line"}
              data-plasmic-override={overrides.line}
              alt={""}
              className={classNames(sty.line)}
              displayHeight={"1067.99px"}
              displayMaxHeight={"none"}
              displayMaxWidth={"100%"}
              displayMinHeight={"0"}
              displayMinWidth={"0"}
              displayWidth={
                hasVariant(globalVariants, "mobile", "tabletPortrait")
                  ? "895px"
                  : "auto"
              }
              loader={"plasmic"}
              loading={"lazy"}
              src={{
                src: "https://site-assets.plasmic.app/f8c2846a1d939511f6aa136587f7afe2.svg",
                fullWidth: 895,
                fullHeight: 1068,
                aspectRatio: 0.838015
              }}
            />
          ) : null}
        </div>
      </section>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  banner: [
    "banner",
    "container",
    "wrapper",
    "heading",
    "title",
    "contentRow",
    "contentColumn",
    "ourCommitmentToSecurityAndCompliance",
    "soc2TypeIiCertified",
    "otherComplianceFeatures",
    "complianceFeatures",
    "hipaa",
    "gdprCompliance",
    "ferpaCompliance",
    "securityMeasuresYouCanTrust",
    "dataEncryption",
    "h4",
    "whyComplianceIsImportant",
    "learnMore",
    "freeBox",
    "links",
    "line"
  ],
  container: [
    "container",
    "wrapper",
    "heading",
    "title",
    "contentRow",
    "contentColumn",
    "ourCommitmentToSecurityAndCompliance",
    "soc2TypeIiCertified",
    "otherComplianceFeatures",
    "complianceFeatures",
    "hipaa",
    "gdprCompliance",
    "ferpaCompliance",
    "securityMeasuresYouCanTrust",
    "dataEncryption",
    "h4",
    "whyComplianceIsImportant",
    "learnMore",
    "freeBox",
    "links",
    "line"
  ],
  wrapper: [
    "wrapper",
    "heading",
    "title",
    "contentRow",
    "contentColumn",
    "ourCommitmentToSecurityAndCompliance",
    "soc2TypeIiCertified",
    "otherComplianceFeatures",
    "complianceFeatures",
    "hipaa",
    "gdprCompliance",
    "ferpaCompliance",
    "securityMeasuresYouCanTrust",
    "dataEncryption",
    "h4",
    "whyComplianceIsImportant",
    "learnMore",
    "freeBox",
    "links",
    "line"
  ],
  heading: ["heading", "title"],
  title: ["title"],
  contentRow: [
    "contentRow",
    "contentColumn",
    "ourCommitmentToSecurityAndCompliance",
    "soc2TypeIiCertified",
    "otherComplianceFeatures",
    "complianceFeatures",
    "hipaa",
    "gdprCompliance",
    "ferpaCompliance",
    "securityMeasuresYouCanTrust",
    "dataEncryption",
    "h4",
    "whyComplianceIsImportant",
    "learnMore",
    "freeBox",
    "links"
  ],
  contentColumn: [
    "contentColumn",
    "ourCommitmentToSecurityAndCompliance",
    "soc2TypeIiCertified",
    "otherComplianceFeatures",
    "complianceFeatures",
    "hipaa",
    "gdprCompliance",
    "ferpaCompliance",
    "securityMeasuresYouCanTrust",
    "dataEncryption",
    "h4",
    "whyComplianceIsImportant",
    "learnMore",
    "freeBox",
    "links"
  ],
  ourCommitmentToSecurityAndCompliance: [
    "ourCommitmentToSecurityAndCompliance"
  ],
  soc2TypeIiCertified: ["soc2TypeIiCertified"],
  otherComplianceFeatures: [
    "otherComplianceFeatures",
    "complianceFeatures",
    "hipaa",
    "gdprCompliance",
    "ferpaCompliance",
    "securityMeasuresYouCanTrust",
    "dataEncryption",
    "h4"
  ],
  complianceFeatures: [
    "complianceFeatures",
    "hipaa",
    "gdprCompliance",
    "ferpaCompliance",
    "securityMeasuresYouCanTrust",
    "dataEncryption",
    "h4"
  ],
  hipaa: ["hipaa"],
  gdprCompliance: ["gdprCompliance"],
  ferpaCompliance: ["ferpaCompliance"],
  securityMeasuresYouCanTrust: [
    "securityMeasuresYouCanTrust",
    "dataEncryption",
    "h4"
  ],
  dataEncryption: ["dataEncryption", "h4"],
  h4: ["h4"],
  whyComplianceIsImportant: ["whyComplianceIsImportant"],
  learnMore: ["learnMore", "freeBox", "links"],
  freeBox: ["freeBox", "links"],
  links: ["links"],
  line: ["line"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  banner: "div";
  container: "section";
  wrapper: "div";
  heading: "div";
  title: "h1";
  contentRow: "div";
  contentColumn: "div";
  ourCommitmentToSecurityAndCompliance: typeof InfoSection;
  soc2TypeIiCertified: typeof InfoSection;
  otherComplianceFeatures: typeof InfoSection;
  complianceFeatures: "div";
  hipaa: "div";
  gdprCompliance: "div";
  ferpaCompliance: "div";
  securityMeasuresYouCanTrust: "div";
  dataEncryption: "div";
  h4: "h4";
  whyComplianceIsImportant: typeof InfoSection;
  learnMore: typeof InfoSection;
  freeBox: "div";
  links: "div";
  line: typeof PlasmicImg__;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicComplianceAndCertificationsBanner__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicComplianceAndCertificationsBanner__VariantsArgs;
    args?: PlasmicComplianceAndCertificationsBanner__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<
      PlasmicComplianceAndCertificationsBanner__VariantsArgs,
      ReservedPropsType
    > &
    // Specify args directly as props
    Omit<
      PlasmicComplianceAndCertificationsBanner__ArgsType,
      ReservedPropsType
    > &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames:
            PlasmicComplianceAndCertificationsBanner__ArgProps,
          internalVariantPropNames:
            PlasmicComplianceAndCertificationsBanner__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicComplianceAndCertificationsBanner__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "banner") {
    func.displayName = "PlasmicComplianceAndCertificationsBanner";
  } else {
    func.displayName = `PlasmicComplianceAndCertificationsBanner.${nodeName}`;
  }
  return func;
}

export const PlasmicComplianceAndCertificationsBanner = Object.assign(
  // Top-level PlasmicComplianceAndCertificationsBanner renders the root element
  makeNodeComponent("banner"),
  {
    // Helper components rendering sub-elements
    container: makeNodeComponent("container"),
    wrapper: makeNodeComponent("wrapper"),
    heading: makeNodeComponent("heading"),
    title: makeNodeComponent("title"),
    contentRow: makeNodeComponent("contentRow"),
    contentColumn: makeNodeComponent("contentColumn"),
    ourCommitmentToSecurityAndCompliance: makeNodeComponent(
      "ourCommitmentToSecurityAndCompliance"
    ),
    soc2TypeIiCertified: makeNodeComponent("soc2TypeIiCertified"),
    otherComplianceFeatures: makeNodeComponent("otherComplianceFeatures"),
    complianceFeatures: makeNodeComponent("complianceFeatures"),
    hipaa: makeNodeComponent("hipaa"),
    gdprCompliance: makeNodeComponent("gdprCompliance"),
    ferpaCompliance: makeNodeComponent("ferpaCompliance"),
    securityMeasuresYouCanTrust: makeNodeComponent(
      "securityMeasuresYouCanTrust"
    ),
    dataEncryption: makeNodeComponent("dataEncryption"),
    h4: makeNodeComponent("h4"),
    whyComplianceIsImportant: makeNodeComponent("whyComplianceIsImportant"),
    learnMore: makeNodeComponent("learnMore"),
    freeBox: makeNodeComponent("freeBox"),
    links: makeNodeComponent("links"),
    line: makeNodeComponent("line"),

    // Metadata about props expected for PlasmicComplianceAndCertificationsBanner
    internalVariantProps:
      PlasmicComplianceAndCertificationsBanner__VariantProps,
    internalArgProps: PlasmicComplianceAndCertificationsBanner__ArgProps
  }
);

export default PlasmicComplianceAndCertificationsBanner;
/* prettier-ignore-end */
